import React, {Component} from 'react';
export default class AdminMenu extends Component {
    render(){
        return  <ul id="sidebarnav">
                        <li>
                            <a className="has-arrow " href="/schedule" aria-expanded="false"><i className="ti-calendar"></i><span className="hide-menu">Scheduler</span></a>
                            
                         </li>                      
                        <li style={{float:'right'}}>
                            <a className="has-arrow " href="/skills" aria-expanded="false"><i className="icon-wrench"></i><span className="hide-menu">Skills</span></a>                            
                        </li>
                         <li style={{float:'right'}}>
                            <a className="has-arrow " href="/peoples" aria-expanded="false"><i className="ti-user"></i><span className="hide-menu">Employee</span></a>                            
                        </li>
                         <li style={{float:'right'}}>
                            <a className="has-arrow " href="/teams" aria-expanded="false"><i className="icon-people"></i><span className="hide-menu">Crew</span></a>
                            
                        </li>
                         <li style={{float:'right'}}>
                            <a className="has-arrow " href="/equipments" aria-expanded="false"><i className="ti-ruler-pencil"></i><span className="hide-menu">Equipment</span></a>
                            
                        </li>
                          <li style={{float:'right'}}>
                            <a className="has-arrow " href="/locations" aria-expanded="false"><i className="icon-location-pin"></i><span className="hide-menu">Location</span></a>
                            
                        </li>
                        
                        
                    </ul>;
    }

}